import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, of, Subscription } from 'rxjs';
import { delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  unSubscribeObservable$: Subscription;
  delayObservable: Observable<boolean>;
  formularioLogin: FormGroup;
  loading = true;
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  ngOnInit(): void {
    this.formularioLogin = this.formBuilder.group({
      racf: [null, Validators.required],
      senha: [null, Validators.required],
    });

    this.delayObservable = of(true).pipe(
      delay(3000),
      tap(() => void this.router.navigate(['dashboard'])),
    );
  }

  onSubmit(): void {
    this.loading = !this.loading;
    this.unSubscribeObservable$ = this.delayObservable.subscribe();
  }
}
